<template>
	<div>
		<a-spin :spinning="loading">
			<div class="ft20 cl-main ftw600">{{artificer}}排班</div>
			
			<div class="mt20 ">
				<a-radio-group v-model="search.mendian_id" button-style="solid" @change="changeMendian">
					<a-radio-button :value="item.mendian_id" v-for="(item,index) in mendians" :key="index">
						{{item.name}}
					</a-radio-button>
				</a-radio-group>
			</div>

			<div class="mt20">
				<div class=" pd30 bg-w" style="min-height: 800px;">
					<div class="">
						<div class="scheduling-table-header">
							<div class="flex alcenter">
								<img src="../../assets/image/icon_title01@2x.png" class="scheduling-table-header-left"/>
								<div style="width: calc(100% - 170px);" class="scheduling-table-header-right">
									<div class="flex alcenter space" style="height: 100%;">
										<div class="last-week-button" @click="getUpWeek()">
											<div class="flex alcenter center">
												<i class="iconfont iconlast ft12 cl-info"/>
												<div class="ml2">上一周</div>
											</div>
										</div>
										
										<div style="width: 100%;" class="flex alcenter">
											<template v-for="(item,index) in getDays">
												<div class="this-week-item flex alcenter center on" v-if="index == selectIndex">
													<div>{{item.today == 1? '今天' : '周'+item.wd}}</div>
													<div class="ml4">{{item.md}}</div>
												</div>
												<div v-else class="this-week-item flex alcenter center" @click="changeDay(index)">
													<div class="cl-main" >{{item.today == 1? '今天' : '周'+item.wd}}</div>
													<div class="ml4">{{item.md}}</div>
												</div>
											</template>
										</div>
										
										<div class="next-week-button" @click="getDownWeek()">
											<div class="flex alcenter center">
												<div >下一周</div>
												<i class="iconfont iconnext ft12 cl-theme ml2"/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						
						<div>
							<div class="scheduling-table-content-technician-item" v-for="(item,index1) in datas">
								<div class="flex alcenter" >
									<div class="scheduling-table-content-technician-item-left flex alcenter">
										<img :src="item.face" />
										<div class="ml10">
											<div class="ft14 ftw500 cl-black">{{item.name}}</div>
											<div class="ft12 ftw400 cl-info mt5">{{item.mobile}}</div>
										</div>
									</div>
									<div class="scheduling-table-content-technician-item-content">
										<div class="flex wrap" v-if="item.schedulings.length>0">
											<div class="scheduling-table-content-technician-scheduling-item" v-for="(scheduling,index2) in item.schedulings">
												<div class="flex alcenter space">
													<div class="flex alcenter pr15">
														<div class="scheduling-table-content-technician-scheduling-item-time flex alcenter ft14 ftw400 cl-main">
															<div>{{scheduling.start_time}}</div>
															<div class="ml10 mr10">-</div>
															<div >{{scheduling.end_time}}</div>
														</div>
														<div :class="scheduling.appointment_num > scheduling.appoint_items_count ? 'available' : 'full'" class="flex">
															<div class="ml16 ft14 ftw400 cl-main text-over4">可约{{ scheduling.appointment_num }}人</div>
															<div class="ml16 ft14 ftw400 cl-main text-over4">已约{{ scheduling.appoint_items_count }}人</div>
														</div>
													</div>
													
													<div class="">
														<i class="iconfont iconno ft14 cl-notice clickAct" @click="delScheduling(index1,index2)"/>
													</div>
												</div>
											</div>
										</div>
										
										<div class="flex alcenter ml20"  v-else>暂无排班</div>
									</div>
									<div class="scheduling-table-content-technician-item-right flex alcenter center">
										<div class="flex alcenter clickAct" @click="addScheduling(index1)">
											<i class="iconfont iconadd_big ft12 cl-theme"/>
											<div class="ml4 ft14 ftw600 cl-theme">添加</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div style="padding-top: 20px;">
							<a-pagination v-model="pagination.current" @change="pageChange" :pageSize="pagination.pageSize" :total="pagination.total" show-less-items />
						</div>
					</div>
					
					<div v-if="addSchedulingVisible">
						<add-scheduling :technician_id="technician_id" :day="getDays[this.selectIndex].day" :visible="addSchedulingVisible" @cancel="cancelAddScheduling" @ok="okAddScheduling"></add-scheduling>
					</div>
				</div>
			</div>
		</a-spin>
		
	</div>
</template>

<script>
	import helper from '../../common/helper.js';
	import addScheduling from './components/TechnicianScheduling/modal/addScheduling.vue';
	export default {
		components:{
			addScheduling
		},
		data() {
			return {
				loading: false,
				addSchedulingVisible:false,
				setting:[],
				week:0,
				selectIndex:0,
				today:null,
				days:[],
				technician_id:0,
				pagination: {
					current: 1,
					pageSize: 10, //每页中显示10条数据
					total: 0,
				},
				search: {
					mendian_id:0
				},
				datas: [],
				mendians: []
			}
		},
		created() {
			let days = helper.getWeekArr();
			this.days = days;
			this.today = helper.getTimeArr();//获取今天
			this.selectIndex = this.today.w;
			this.getLists();
			this.getMendians();
		},
		computed:{
			getDays(){
				if(this.today == null) return [];
				let arr = new Array;
				for(var a  in this.days){
					arr.push({
						today:this.days[a].today,
						md:this.days[a].md,
						wd:this.days[a].wd,
						day:this.days[a].y + '-' +this.days[a].m + '-'+this.days[a].d,
					});
				}
				return arr;
			}
		},
		methods: {
			getMendians(){
				this.$http.api('admin/getAllMendian').then(res=>{
					this.mendians = res.mendian;
				}).catch(res=>{
					console.log(res);
				});
			},
			getLists(){
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('admin/showTechnicianScheduling',{
					limit:this.pagination.pageSize,
					page:this.pagination.current,
					day:this.getDays[this.selectIndex].day,
					mendian_id:this.search.mendian_id,
				}).then(res=>{
					
					this.pagination.total=res.total;
					this.datas=res.list;
					this.loading=false;
					
				}).catch(res=>{
			
					this.loading=false;
				})
			},
			
			//添加排班
			addScheduling(index){
				this.technician_id=this.datas[index].technician_id;
				this.addSchedulingVisible=true;
			},
			cancelAddScheduling(){
				this.addSchedulingVisible=false;
			},
			okAddScheduling(){
				this.addSchedulingVisible=false;
				this.getLists();
			},
			
			delScheduling(index1,index2){
				this.$confirm({
					title:'确认删除这个排班吗？',
					okText:"确定",
					okType:"danger",
					cancelText:"取消",
					onOk : ()=>{
						return new Promise((resolve,reject)=>{
							this.$http.api('admin/delTechnicianScheduling',{
								scheduling_id:this.datas[index1].schedulings[index2].scheduling_id,
							}).then(res=>{
								this.$message.success('删除成功',1,()=>{
									this.datas[index1].schedulings.splice(index2,1);
								});
							}).catch(res=>{
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
					}
				})
				
			},
			
			getUpWeek(){
				this.week = this.week - 1;
				let days = helper.getWeekArr(this.week);
				this.days = days;
				this.getDatas();
			},
			getDownWeek(){
				this.week = this.week + 1;
				let days = helper.getWeekArr(this.week);
				this.days = days;
				this.selectIndex = 0;
				this.getDatas();
			},
			
			changeDay(index){
				this.selectIndex=index;
				this.getDatas();
			},
			
			getDatas(){
				this.loading=false;
				this.pagination.current=1;
				this.getLists();
			},
			
			pageChange(e){
			    this.pagination.current = parseInt(e);
			    this.getLists();
			},
			changeMendian() {
				this.pagination.current = 1;
				this.getLists();
			},
		}
	}
</script>

<style>
	.setting-item{
		width: 14px;
		height: 14px;
	}
	
	.scheduling-table-header{
		width: 100%;
		height: 60px;
		background: #FFFFFF;
	}
	
	.scheduling-table-header-left{
		width: 170px;
		height: 60px;
	}
	.scheduling-table-header-right{
		width: calc(100% - 170px);
		height: 60px;
		border: 1px solid #EBEDF5;
		border-left: none;
		padding: 0px 20px;
		line-height: 1;
	}
	
	.last-week-button{
		width: 90px;
		height: 40px;
		background: #FFFFFF;
		border-radius: 4px;
		border: 1px solid #EBEDF5;
		font-size: 14px;
		font-weight: 500;
		color: #656A75;
		text-align: center;
		line-height: 38px;
		cursor: pointer;
	}
	
	.this-week-item{
		height: 40px;
		font-size: 12px;
		font-weight: 500;
		color: #A6AEC2;
		width: 10%;
		margin-left: 3%;
		margin-left: 3%;
		cursor: pointer;
	}
	
	.this-week-item.on{
		height: 40px;
		background: #4772FF;
		border-radius: 4px;
		color: #FFFFFF;
	}
	
	.next-week-button{
		width: 90px;
		height: 40px;
		background: #FFFFFF;
		border-radius: 4px;
		border: 1px solid #4772FF;
		font-size: 14px;
		font-weight: 500;
		color: #4772FF;
		text-align: center;
		line-height: 38px;
		cursor: pointer;
	}
	
	.scheduling-table-content-technician-item{
		width: 100%;
		min-height: 80px;
		background: #FFFFFF;
		border: 1px solid #EBEDF5;
		border-top: none;
	}
	
	.scheduling-table-content-technician-item-left{
		width: 168px;
		height: 100%;
		background: #FFFFFF;
		padding: 20px;
		line-height: 1;
	}
	.scheduling-table-content-technician-item-left img{
		width: 40px;
		height: 40px;
		border-radius: 2px;
	}
	
	.scheduling-table-content-technician-item-content{
		width: calc(100% - 272px);
		min-height: 80px;
		border-left: 1px solid #EBEDF5;
		border-right: 1px solid #EBEDF5;
		padding: 15px 0px;
	}
	
	.scheduling-table-content-technician-scheduling-item{
		width: 320px;
		height: 40px;
		background: #FFFFFF;
		border-radius: 4px;
		border: 1px solid #EBEDF5;
		padding: 10px 16px;
		margin-left: 20px;
		margin-bottom: 10px;
	}
	
	.scheduling-table-content-technician-scheduling-item-time{
		border-right: 1px solid #EBEDF5;
		padding-right: 16px;
		line-height: 1;
	}
	
	.scheduling-table-content-technician-item-right{
		width: 104px;
		height: 100%;
		line-height: 1;
	}
	.available {
		background-color: #66ff66; 
	}
	.full {
		background-color: #ff6666; 
	}
</style>
